import React from "react"
import { graphql, useStaticQuery, Link } from "gatsby"
import { getImage } from "gatsby-plugin-image"
import { BgImage } from "gbimage-bridge"
import styled from "styled-components"

const HeroArchitecture = () => {
  const { placeholderImage } = useStaticQuery(
    graphql`
      query {
        placeholderImage: file(
          relativePath: { eq: "architecture/birdseyeGGBc.jpg" }
        ) {
          childImageSharp {
            gatsbyImageData(
              placeholder: BLURRED
              formats: [AUTO, WEBP, AVIF]
              layout: FIXED
              quality: 100
            )
          }
        }
      }
    `
  )
  const pluginImage = getImage(placeholderImage)

  return (
    <Wrapper>
      <BgImage
        image={pluginImage}
        css={`
          position: absolute;
          right: 90%;

          @media screen and (min-width: 600px) {
            right: 0;
          }
        `}
      />
      <Text to="/portfolio#architecture">
        <p>World Famous</p>
        <p>ARCHITECTURE</p>
      </Text>
    </Wrapper>
  )
}

export default HeroArchitecture

const Wrapper = styled.div`
  position: relative;

  :before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    background: linear-gradient(rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.1) 100%);
  }
`

const Text = styled(Link)`
  color: #fff;
  text-decoration: none;
  position: absolute;
  top: 25vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  z-index: 2;

  p:first-child {
    font-size: clamp(2.5rem, 5vw, 4.2rem);
  }

  p:nth-child(2) {
    font-size: clamp(3.8rem, 12.5vw, 12rem);
  }

  @media screen and (max-width: 499px) {
    p:first-child {
      font-size: 2rem;
    }

    p:nth-child(2) {
      font-size: 3rem;
    }
  }
`
